module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-1-5ca27e6fd48e98e49b23d7918bb31103.png";